import { StyledFormOption, StyledFormSelect, StyledFormTableSelect } from "./select.styles";

export const FormSelect = ({ children, ...props }) => {
  return <StyledFormSelect {...props}>{children}</StyledFormSelect>;
};

export const FormTableDataSelect = ({ children, ...props }) => {
  return <StyledFormTableSelect {...props}>{children}</StyledFormTableSelect>;
};

export const FormOption = ({ children, ...props }) => {
  return <StyledFormOption {...props}>{children}</StyledFormOption>;
};
